var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLadder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 30C32 30.5523 32.4477 31 33 31C33.5523 31 34 30.5523 34 30V26.4142L34.2929 26.7071C34.6834 27.0976 35.3166 27.0976 35.7071 26.7071C36.0976 26.3166 36.0976 25.6834 35.7071 25.2929L33.7071 23.2929C33.3166 22.9024 32.6834 22.9024 32.2929 23.2929L30.2929 25.2929C29.9024 25.6834 29.9024 26.3166 30.2929 26.7071C30.6834 27.0976 31.3166 27.0976 31.7071 26.7071L32 26.4142V30Z",
    fill: "#006FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.001 8C15.001 6.89543 15.8964 6 17.001 6H23.001C24.1055 6 25.001 6.89543 25.001 8V10H36.001C37.1055 10 38.001 10.8954 38.001 12V22.102C39.2376 23.3645 40 25.0932 40 27C40 30.866 36.866 34 33 34C31.0927 34 29.3636 33.2372 28.101 32H4.00098C2.89641 32 2.00098 31.1046 2.00098 30V16.0445C1.99968 16.0153 1.99967 15.986 2.00098 15.9565V12C2.00098 10.8954 2.89641 10 4.00098 10H15.001V8ZM26.6736 30H4.00098V17.3259L16 20.7542V21C16 22.1046 16.8954 23 18 23H22C23.1046 23 24 22.1046 24 21V20.7544L36.001 17.3255V20.6741C35.0915 20.2419 34.074 20 33 20C29.134 20 26 23.134 26 27C26 28.0736 26.2417 29.0907 26.6736 30ZM36.001 15.2455L23.9748 18.6815C23.8223 17.7283 22.9962 17 22 17H18C17.0039 17 16.1778 17.7283 16.0252 18.6814L4.00098 15.2459V12H36.001V15.2455ZM23.001 8V10H17.001V8H23.001ZM18 19.9675C18.0007 19.9888 18.0007 20.0101 18 20.0315V21H22V19H18V19.9675ZM38 27C38 29.7614 35.7614 32 33 32C30.2386 32 28 29.7614 28 27C28 24.2386 30.2386 22 33 22C35.7614 22 38 24.2386 38 27Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadder);
export default __webpack_public_path__ + "static/media/ladder.14abe58089d5bbfea657bdead4321a91.svg";
export { ForwardRef as ReactComponent };